/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Typography, Descriptions, Select, Form } from 'antd';

import { getRouteGroups } from '../../services/pos/pos';
import ZonalRestriction from './ZonalRestriction';

const LineGroupsRestriction = ({ form, name, line, whereIsRestriction }) => {
  const [routeGroups, setRouteGroups] = useState([]);
  useEffect(() => {
    getRouteGroups().then((response) =>
      setRouteGroups(
        response.reduce((acc, val) => ({ ...acc, [val.id]: val }), {}),
      ),
    );
  }, [form, name]);

  const [productIdx, _rest, restrictionIdx] = name;
  const values = form.getFieldsValue([
    ['product', 'payload', productIdx, 'restrictions', restrictionIdx],
  ]);
  const res = values.product.payload[productIdx].restrictions[restrictionIdx];
  const { value1, value2, value3, value4, value5, value6, value7, value8 } =
    res;

  useEffect(() => {
    if (whereIsRestriction.length > 0) {
      const flatRestArr = whereIsRestriction.flat();
      if (flatRestArr.some((val) => val === 'value1')) {
        res.option1 = line;
      } else if (flatRestArr.some((val) => val === 'value3')) {
        res.option2 = line;
      } else if (flatRestArr.some((val) => val === 'value5')) {
        res.option3 = line;
      } else if (flatRestArr.some((val) => val === 'value7')) {
        res.option4 = line;
      }
    }
  }, [res, line, whereIsRestriction]);

  return (
    <Descriptions bordered column={1}>
      {value2 && (
        <Descriptions.Item label={routeGroups[value2]?.name}>
          {value1 === 1 ? (
            <Form.Item name={[restrictionIdx, 'option1']} noStyle>
              <Select
                disabled={whereIsRestriction
                  .flat()
                  .some((val) => val === 'value1')}
              >
                {(routeGroups[value2]?.routes || []).map((route) => (
                  <Select.Option value={route.id} key={route.id}>
                    {route.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          ) : (
            'Toate liniile'
          )}
        </Descriptions.Item>
      )}

      {value4 && (
        <Descriptions.Item label={routeGroups[value4]?.name}>
          {value3 === 1 ? (
            <Form.Item name={[restrictionIdx, 'option2']} noStyle>
              <Select
                disabled={whereIsRestriction
                  .flat()
                  .some((val) => val === 'value3')}
              >
                {(routeGroups[value4]?.routes || []).map((route) => (
                  <Select.Option value={route.id} key={route.id}>
                    {route.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          ) : (
            'Toate liniile'
          )}
        </Descriptions.Item>
      )}

      {value6 && (
        <Descriptions.Item label={routeGroups[value6]?.name}>
          {value5 === 1 ? (
            <Form.Item name={[restrictionIdx, 'option3']} noStyle>
              <Select
                disabled={whereIsRestriction
                  .flat()
                  .some((val) => val === 'value5')}
              >
                {(routeGroups[value6]?.routes || []).map((route) => (
                  <Select.Option value={route.id} key={route.id}>
                    {route.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          ) : (
            'Toate liniile'
          )}
        </Descriptions.Item>
      )}

      {value8 && (
        <Descriptions.Item label={routeGroups[value8]?.name}>
          {value7 === 1 ? (
            <Form.Item name={[restrictionIdx, 'option4']} noStyle>
              <Select
                disabled={whereIsRestriction
                  .flat()
                  .some((val) => val === 'value7')}
              >
                {(routeGroups[value8]?.routes || []).map((route) => (
                  <Select.Option value={route.id} key={route.id}>
                    {route.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          ) : (
            'Toate liniile'
          )}
        </Descriptions.Item>
      )}
    </Descriptions>
  );
};

const Restriction = ({ form, name, line, whereIsRestriction, title }) => {
  const { t } = useTranslation();
  const [productIdx, _rest, restrictionIdx] = name;

  const values = form.getFieldsValue([
    ['product', 'payload', productIdx, 'restrictions', restrictionIdx],
  ]);

  const category = form.getFieldValue(['product', 'category']);

  const metropolitanEnabled = useMemo(
    () => window._env_.METROPOLITAN_ENABLE === 'true',
    [],
  );

  const res = values.product.payload[productIdx].restrictions[restrictionIdx];
  const { restriction } = res;

  if (restriction === 'USAGE_PER_PERIOD') {
    res.option1 = res.value1;
    res.option2 = res.value2;
  }

  const renderRestrictionComponent = useCallback(
    (r) => {
      switch (r) {
        case 'LINE_GROUPS':
          return (
            <>
              <Typography.Paragraph>
                {t(`entity.offers.restrictions.restriction.${r}._`)}
              </Typography.Paragraph>
              <LineGroupsRestriction
                form={form}
                name={name}
                line={line}
                whereIsRestriction={whereIsRestriction}
              />
            </>
          );
        case 'ZONAL':
          return (
            metropolitanEnabled &&
            category === 'PASS' && (
              <>
                <Typography.Paragraph>
                  {t(`entity.offers.restrictions.restriction.${r}._`)}
                </Typography.Paragraph>
                <ZonalRestriction form={form} name={name} title={title} />
              </>
            )
          );
        default:
          return null;
      }
    },
    [
      form,
      name,
      t,
      line,
      whereIsRestriction,
      category,
      metropolitanEnabled,
      title,
    ],
  );

  return <>{renderRestrictionComponent(restriction)}</>;
};

export default Restriction;
